module.exports = __webpack_public_path__ + "static/img/6011_phase_function_Paper_Points.2991e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6011_phase_function_Paper_Points.png
// module id = USoe
// module chunks = 0